<template>
  <div>
    <h2>
      <el-button class="pull-right"
                 v-if="canAdd()"
                 @click="showDialog()"
                 type="primary">Nuevo</el-button>
      Usuarios
    </h2>
    <app-table
      @change-pagination="onChangePagination"
      @change-search="onChangeSearch"
      :total="total">

      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%">
        <el-table-column
          prop="username"
          label="Nombre de Usuario">
        </el-table-column>
        <el-table-column
          prop="name"
          label="Nombre">
        </el-table-column>
        <el-table-column
          prop="email"
          label="Correo">
        </el-table-column>
        <el-table-column
          width="100">
          <template slot-scope="scope">
            <el-button
              v-if="canUpdate()"
              size="mini"
              type="warning"
              @click="showDialog(scope.row)">
              <i class="el-icon-edit"></i>
            </el-button>
            <el-button
              v-if="!canUpdate() && canShow()"
              size="mini"
              type="primary"
              @click="showDialog(scope.row)">
              <i class="fa fa-eye"></i>
            </el-button>
            <el-button
              v-if="canDelete()"
              type="danger"
              size="mini"
              @click="handleDelete(scope.$index, scope.row)">
              <i class="el-icon-delete"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </app-table>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible">
      <el-form ref="form" :model="form" :rules="rules" label-position="top">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Nombre de Usuario" prop="username">
              <el-input v-model="form.username" :disabled="canEditToSave()" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Nombre" prop="name">
              <el-input v-model="form.name" :disabled="canEditToSave()" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Correo" prop="email">
              <el-input type="email" v-model="form.email" :disabled="canEditToSave()" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="full-form">
            <el-form-item label="Rol" prop="role_id">
              <el-select v-model="form.role_id"
                         @change="onChangeRole()"
                         :disabled="canEditToSave()"
                         :placeholder="(loadingRoles) ? 'Cargando...' :'Seleccionar Rol'">
                <el-option
                  v-for="item in roles"
                  :key="item.id"
                  :label="item.display_name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" class="full-form" v-if="form.role_id == 2">
            <el-form-item label="Centro de Costo" prop="cost_centers">
              <el-select v-model="form.cost_centers"
                         multiple
                         :disabled="canEditToSave()"
                         :placeholder="(loadingCostCenters) ? 'Cargando...' :'Seleccionar Centro de Costo'">
                <el-option
                  v-for="item in cost_centers"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="!form.id">
          <el-col :span="12">
            <el-form-item label="Contraseña" prop="password">
              <el-input type="password"
                        :disabled="canEditToSave()"
                        v-model="form.password"
                        auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Confirmación" prop="password_confirmation">
              <el-input type="password"
                        v-model="form.password_confirmation"
                        :disabled="canEditToSave()"
                        auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <div role="alert" v-if="error.message" class="el-alert el-alert--error">
        <div class="el-alert__content">
          <span class="el-alert__title is-bold">{{ error.message }}</span>
          <p class="el-alert__description">
            <ul>
              <li v-for="item in error.errors">{{ item[0] }}</li>
            </ul>
          </p>
        </div>
      </div>
      <el-alert
        v-if="success"
        title="Se ha guardado exitosamente."
        type="success">
      </el-alert>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancelar</el-button>
        <el-button type="primary"
                   v-if="!canEditToSave()"
                   :loading="processing"
                   @click="save()">Guardar</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import AppTable from '../../components/Table'
  import BaseCrud from '../../components/abstract/BaseCrud'
  import {parseError} from '../../packages/Helpers'
  import {baseApi} from '../../configs/urls'

  export default {
    name: 'user-list',
    extends: BaseCrud,
    components: {
      AppTable
    },
    data () {
      const validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Por favor ingresa la contraseña'))
        } else {
          if (this.form.password_confirmation !== '') {
            this.$refs.form.validateField('password_confirmation')
          }
          callback()
        }
      }

      const validatePassConfirmation = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Ingresa la contraseña otra vez'))
        } else if (value !== this.form.password) {
          callback(new Error('La confirmacion no coincide!'))
        } else {
          callback()
        }
      }
      return {
        baseUrl: baseApi + '/users',
        basePermission: 'users',
        form: {
          name: '',
          username: '',
          email: '',
          password: '',
          password_confirmation: ''
        },
        loadingRoles: false,
        loadingCostCenters: false,
        roles: [],
        cost_centers: [],
        rules: {
          username: [
            { required: true, message: 'El nombre de usuario es requerido', trigger: 'blur' }
          ],
          name: [
            { required: true, message: 'El nombre es requerido', trigger: 'blur' }
          ],
          role_id: [
            { required: true, message: 'El rol es requerido', trigger: 'blur' }
          ],
          cost_centers: [
            { required: true, message: 'El Centro de Costo es requerido', trigger: 'blur' }
          ],
          email: [
            { required: true, message: 'El nombre de usuario es requerido', trigger: 'blur' },
            { type: 'email', message: 'El correo debe ser valido', trigger: 'blur,change' }
          ],
          password: [
            { required: true, message: 'La contraseña es requerida', trigger: 'blur' },
            { min: 8, message: 'Por lo menos debe tener 8 caracters', trigger: 'blur' },
            { validator: validatePass, trigger: 'blur' }
          ],
          password_confirmation: [
            { validator: validatePassConfirmation, trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      _beforeRefresh (query) {
        query.role = true
        query.cost_center = true
      },
      _formatModel (model) {
        if (model.roles.length > 0) {
          model.role_id = model.roles[0].id
        }
        if (model.cost_centers.length > 0) {
          model.cost_centers = model.cost_centers.map((item) => item.id)
        }
      },
      _beforeSend (model) {
        console.log(model)
        return model
      },
      _mounted () {
        this.loadingRoles = true
        this.$http.get(baseApi + '/roles')
          .then(
            (response) => {
              this.roles = response.body
              this.loadingRoles = false
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.loadingRoles = false
            }
          )

        this.loadingCostCenters = true
        this.$http.get(baseApi + '/cost-centers')
          .then(
            (response) => {
              this.cost_centers = response.body
              this.loadingCostCenters = false
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.loadingCostCenters = false
            }
          )
      },
      onChangeRole () {
        if (Number(this.form.role_id) !== 2) {
          this.form.cost_center_id = null
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/users/UserList.vue